import { observer } from 'mobx-react-lite';

import { FormLabel } from '@components/form-label';
import { Stack } from '@components/stack';
import { TextEditor } from '@components/text-editor';

import { TextEditorToolbar } from 'components/TextEditorToolbar';
import { usePlaceholderMap } from 'hooks/use-placeholder-map';
import { useStore } from 'models/Provider';

import TemplateSelector from './TemplateSelector';

function Form({ templates, selected, setEditorState, disabled, onSelect }) {
  const { t } = useStore();
  const placeholderMap = usePlaceholderMap('message');

  return (
    <Stack space={4}>
      {templates.length > 0 && <TemplateSelector templates={templates} onChange={onSelect} />}

      <Stack space={1}>
        <FormLabel text={t('rejectform.label.message')} />
        <TextEditor
          key={selected.id}
          variant="gray"
          readOnly={disabled}
          initialEditorState={selected.message}
          onChange={setEditorState}
        >
          <Stack orientation="horizontal" justify="space-between" space={2} align="center">
            <TextEditorToolbar />
            <TextEditor.PlaceholderMenu
              label={t('editor.placeholder.title')}
              placeholderMap={placeholderMap}
            />
          </Stack>
          <TextEditor.Input />
        </TextEditor>
      </Stack>
    </Stack>
  );
}

export default observer(Form);
